const r = (r2) => {
  const a2 = /* @__PURE__ */ new Map();
  return r2.forEach((r3) => {
    r3.forEach((r4, t) => {
      const e = r4.id ?? r4.identityId ?? `null-${t}-${Math.random()}`;
      a2.set(e, r4);
    });
  }), Array.from(a2.values()).map((r3, a3) => ({ ...r3, __rowId: a3 + 1, __id: a3 + 1 }));
}, a = (a2, t) => (e, n) => {
  var _a, _b, _c;
  const s = a2(e, n), o = t ? (_b = (_a = s.data) == null ? void 0 : _a.pages) == null ? void 0 : _b.map((r2) => r2[t]) : (_c = s.data) == null ? void 0 : _c.pages, i = (p = o ?? [], Array.isArray(p) ? p.map((r2) => {
    if (Array.isArray(r2)) return r2;
    if ("string" == typeof r2) try {
      const a3 = JSON.parse(r2);
      if (Array.isArray(a3)) return a3;
    } catch {
      console.warn("Failed to parse page as JSON");
    }
    return [];
  }) : []);
  var p;
  return { ...s, data: r(i) };
};
export {
  r as addRowIdsAndDeduplicate,
  a as normalizeInfiniteQueryData
};
//# sourceMappingURL=normalizeInfiniteQueryData.js.map
